module.exports = __webpack_public_path__ + "img/hr-stoxos.9efd199d.png";